export const PR_STATE_MERGED = 'merged';
export const PR_STATE_OPEN = 'open';
export const PR_STATE_CLOSED = 'closed';
export const PR_STATE_ALL = 'all';
export const PR_STATE_NOT_OPEN = '!open';
